import { normalizeShopIdentifier } from './productGuideFeature';

// Service Booking is shelved. Keep the tenant list empty until deliberate reactivation.
const enabledShopIdentifiers = new Set<string>();

export const isServiceBookingEnabledForShop = (shopDomain?: string | null) =>
    enabledShopIdentifiers.has(normalizeShopIdentifier(shopDomain));
